<!-- <div class="m-2"> -->
	<mat-card class="mt-2" *ngIf="isEditing && validationErrors.length > 0">
		<mat-card-content>
			<!-- Validation Errors Section -->
			<div class="mt-3">
				<mat-card class="validation-errors-card">
					<mat-card-content>
						<div class="d-flex align-items-start">
							<mat-icon color="warn" class="me-2">warning</mat-icon>
							<div class="flex-grow-1">
								<h4
									class="mat-h4 mb-2"
									style="color: #f44336; margin: 0"
								>
									Please fix the following errors:
								</h4>
								<ul class="mb-0" style="padding-left: 20px">
									<li
										*ngFor="let error of validationErrors"
										style="color: #d32f2f; margin-bottom: 4px"
									>
										{{ error }}
									</li>
								</ul>
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</mat-card-content>
	</mat-card>

	<div class="section-page">
		<!-- Add "section-header-bar--flush" to make the sticky header also bleed flush against the side nav -->
		<div class="section-header-bar" [class.section-header-bar--scrolled]="isScrolled">
			<div class="section-header">
				<div class="section-header__title">
					<mat-icon class="section-header__icon">assignment</mat-icon>
					<div>
						<div class="section-header__heading">{{ sectionHeader.label }}</div>
						<div class="section-header__subtitle" *ngIf="sectionHeader.description">{{ sectionHeader.description }}</div>
					</div>
				</div>
				<div class="section-header__actions">
					<span class="last-update" *ngIf="lastUpdate">Last Update : {{ lastUpdate }}</span>
					<ng-container *ngIf="isEditing">
						<button mat-raised-button color="primary" (click)="onSaveClick($event)">
							<mat-icon>save</mat-icon>
							Save
						</button>
						<button mat-raised-button color="primary"
							(click)="onCancelClick($event)" *ngIf="false">
							<mat-icon>cancel</mat-icon>
							Cancel
						</button>
					</ng-container>
					<ng-container *ngIf="!isEditing">
						<button mat-raised-button color="primary" (click)="onEditClick($event)">
							<mat-icon>edit</mat-icon>
							Edit
						</button>
					</ng-container>
				</div>
			</div>
		</div>

		<mat-accordion multi>
			<form [formGroup]="form">
				<formly-form
					[form]="form"
					[fields]="fields"
					[model]="model"
					(modelChange)="onModelChange($event)">
				></formly-form>
			</form>
		</mat-accordion>
	</div>
<!-- </div> -->
